import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

import {UserBadge} from 'app/profile/model/model';
import {UserService} from 'app/profile/services/user.service';
import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';

import {Badge} from '../../model/model';
import { DefaultPage } from 'app/menu/components/default-page/default-page';
@Component({
  selector: 'badge-detail-page',
  templateUrl: 'badge-detail-page.html',
  styleUrls: ['badge-detail-page.scss'],
})
export class BadgeDetailPage extends DefaultPage {

  public badge: Badge;
  public userBadge: UserBadge = null;

  constructor(
    public navService: NavService,
    private translateService: TranslateService,
    private userService: UserService,
  ) {
    super(navService);
    this.badge = <Badge> this.navService.get('badge');
    this.userBadge = <UserBadge> this.navService.get('userBadge');
  }

  private ionViewWillEnter(): void {
    // mark as read (no more new)
    if (this.userBadge && this.userBadge.new) {
      this.userService.markBadgeDisplayed(this.userBadge._id).subscribe();
      this.userBadge.new = false;
      this.userService.setNewBadgeCount(this.userService.getNewBadgeCount() - 1);
    }
  }

  public get badgeTitle(): string {
    if (this.badge) {
      return getTranslation(this.badge.title, this.translateService);
    }

    return '';
  }

  public get badgeDescription(): string {
    if (this.badge) {
      return getTranslation(this.badge.description, this.translateService);
    }

    return '';
  }
  public get userBadgeDatum(): string {
    return moment(this.userBadge.createdAt).format('DD.MM.YYYY');
  }

  public get badgeClass(): string {
    return this.userBadge ? '' : 'inactive';
  }
}
